import { Pipe, PipeTransform } from '@angular/core';

/**
 * Looking for sip number in sip uri
 */
@Pipe({
  standalone: true,
  name: 'sipUriNumber',
})
export class SipUriNumberPipe implements PipeTransform {
  transform(sipUri?: string): string {
    if (sipUri) {
      const regex = /^sip:([^@]+)/;
      const match = sipUri.match(regex);
      return match ? match[1] : sipUri;
    } else {
      return '';
    }
  }
}
